module.exports = __webpack_public_path__ + "static/media/fundo_grey.e3c6eb65.png";